// source: design/src/pages/SIPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
export default {
  common: {
    coreModules: '核心機能モジュール',
    coreModulesEN: 'Core Functional Modules',
    scenarios: '適用業種・シーン',
    scenariosEn: 'Use Cases',
    benefits: 'システム導入の主な効果',
    benefitsEn: 'Significant benefits of using the core system',
    cta: '「飛狼」の事業について、ぜひ詳しくご覧ください',
    learnMore: '詳細を見る',
    breadcrumb: {
      home: 'ホーム',
      products: '製品とサービス',
      si: 'SI システムインテグレーション',
    },
  },
  heroTitle: 'SI システムインテグレーション',
  heroSubtitle: 'System Integration',
  heroDesc: '企業の実際の業務ニーズに基づき、MES、WMS、AIなどのシステムや技術を統合して業務プロセスとデータを連携させ、システム間の効率的な協調を実現するとともに、統一的かつ柔軟なデジタル管理体制を構築します。',
  intro: [
    '企業の実際の業務シナリオに基づき、システム計画、設計、開発、統合、導入を網羅する包括的なソリューションを提供します。',
    '製造実行システム（MES）、倉庫管理システム（WMS）、AIなどの異なるシステムや技術を統合し、生産、倉庫、物流、設備、管理といった業務プロセスを連携させることで、企業内のデータと業務フローを接続し、システム間での情報共有と協調的な運用を実現します。',
    '企業の既存のIT環境や業務ニーズに合わせて柔軟に統合を行い、システム間の情報の分断（サイロ化）を解消し、業務プロセスの最適化や生産運用効率の向上を支援するとともに、拡張性のあるデジタル基盤を段階的に構築します。',
  ],
  solutionsTitle: 'ソリューション',
  solutionsSubtitle: 'Our Solutions',
  solutions: [
    {
      icon: 'si/si-icons/factory.svg',
      title: 'MES 製造実行システム',
      desc: 'ERP計画層と現場実行層を連携させ、生産スケジューリング、品質管理、設備連携のリアルタイム可視化を実現し、スマート製造の最後の1マイルをつなぎます。',
      routeName: 'si-mes',
    },
    {
      icon: 'si/si-icons/warehouse.svg',
      title: 'WMS 倉庫管理システム',
      desc: '入庫、ロケーション、ピッキング、出庫の全工程を最適化し、在庫のリアルタイム可視化とインテリジェントなウェーブ計画を実現し、倉庫の運営効率と精度を向上させます。',
      routeName: 'si-wms',
    },
    {
      icon: 'si/si-icons/brain.svg',
      title: 'AI',
      desc: '作業指示管理、人員の配備・割り当て、現場作業、設備保守などの業務プロセスを統合し、サービスリソースの一元管理とリアルタイムな連携を実現することで、フィールドサービスの効率と顧客満足度を向上させます。',
      routeName: 'si-ai',
    },
  ],
  contact: 'お問い合わせ',
};
